









































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class IspezioneSign extends Vue {
  @Prop() docInfo!: any;

  close() {
    this.clearEnterpriseSignature();
    bus.$emit("closeDocSignDialog");
  }
  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }
  save() {
    var signatureAziendaEmpty: boolean = true;
    //@ts-ignore
    const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
    if (signatureAzienda.isEmpty === false) {
      const payload = {
        idIspezione: this.docInfo.idIspezione,
        firmaAzienda: signatureAzienda.data
      };
      
      user
        .dispatchSignIspezione(this["$store"], payload)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Visita confermata con successo"
          );
          bus.$emit("loadIspezione");
          this.close();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }
  refuse() {
    var payload = {
      idIspezione: this.docInfo.idIspezione
    };
    if (confirm("Si è certi che non sia stata effettuata nessuna visita?")) {
      user
        .dispatchRefuseIspezione(this["$store"], payload)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Visita rifiutata correttamente"
          );
          bus.$emit("loadIspezione");
          this.close();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }
}
